// Recording data transformer

import { BaseTransformer } from './BaseTransformer';

export class RecordingTransformer extends BaseTransformer {
  
  async transform(recordingData: Record<string, unknown>): Promise<Record<string, unknown>> {
    console.log(`[RECORDING-TRANSFORM] Processing recording ${recordingData.id} with transcription:`, !!recordingData.text);
    
    // Handle duration properly - could be float or string
    let durationSeconds = 0;
    if (typeof recordingData.duration === 'number') {
      durationSeconds = Math.round(recordingData.duration);
    } else if (recordingData.duration) {
      // Parse as float first, then round
      const parsed = parseFloat(String(recordingData.duration));
      durationSeconds = isNaN(parsed) ? 0 : Math.round(parsed);
    }
      
    console.log(`[RECORDING-TRANSFORM] Transformed duration: ${durationSeconds}s, has transcription: ${!!recordingData.text}`);

    return this.pruneUndefined({
      id: recordingData.id,
      case_id: recordingData.cID || recordingData.case_id,
      file_path: recordingData.storagePath || recordingData.storage_path || 'recordings/unknown-file.wav',
      duration: recordingData.duration, // Keep original duration field for Supabase service
      duration_seconds: durationSeconds, // Our calculated duration_seconds
      transcription: recordingData.text || recordingData.transcription || null,
      summary: recordingData.summary || null,
      segments: recordingData.segments || null,
      exclude_from_template: this.safeBoolean(recordingData.exclude_from_template),
      created_at: recordingData.createdAt || this.getCurrentTimestamp(),
      updated_at: this.getCurrentTimestamp()
    });
  }
} 